import {HttpClient, HttpErrorResponse, HttpHeaders, HttpParams} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {User} from '../models/user';
import {Observable, of, throwError} from 'rxjs';
import { catchError, tap, map } from 'rxjs/operators';
import {ApiResponse} from '../models/api.response';

const apiUrl = '/gsb/stock';
@Injectable()
export class StockService {
    constructor(private http: HttpClient) { }

    getAll(year, selectedCentreId, selectedProductId): Observable<any> {
      const url = `${apiUrl}/` + year;

      let params = new HttpParams();
      if (selectedProductId) {
        params = params.set('productId', String(selectedProductId));
      } else {
        params = params.set('productId', String(-1));
      }
      if (selectedCentreId) {
        params = params.set('centreId', String(selectedCentreId));
      } else {
        params = params.set('centreId', String(-1));
      }

      return this.http.get<any>(url, {params: params});
    }

    getAllByPeriode(dateDebut, dateFin, selectedCentreId, selectedProductId): Observable<any> {
      const url = `${apiUrl}/byPeriode`;

      let params = new HttpParams();
      if (selectedProductId) {
        params = params.set('productId', String(selectedProductId));
      } else {
        params = params.set('productId', String(-1));
      }
      if (selectedCentreId) {
        params = params.set('centreId', String(selectedCentreId));
      } else {
        params = params.set('centreId', String(-1));
      }

      const dateDebutStr = (dateDebut.getMonth() + 1) + '/' + dateDebut.getDate() + '/' + dateDebut.getFullYear();
      const dateFinStr =  (dateFin.getMonth() + 1) + '/' + dateFin.getDate()  + '/' + dateFin.getFullYear();
      params = params.set('dateDebut', String(dateDebutStr));
      params = params.set('dateFin', String(dateFinStr));

      return this.http.get<any>(url, {params: params});
    }

}
